export default "__VITE_ASSET__mjG493Sx__"